import React from "react";
import { AppBar, Toolbar, Button, Box, Typography } from "@mui/material";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import PaperliveLogo from "../images/paperlive-new-logo.webp";
import CourseDropdown from "./CourseDropdown";
import NavbarMobile from "./NavbarMobile";
import PaperliveXIITPatna from "../images/PaperliveXIITPatna.webp";
import { EXECUTIVE_PG_DEVOPS_PROGRAM, EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT } from "../../constants/AzureDevops";

const Navbar = ({ isSmallScreen, scrollToSection, course }) => {
  const isBlogPage = window.location.pathname.startsWith("/blog") || 
  window.location.pathname.startsWith("/about-us") || window.location.pathname.startsWith("/refund-policy") || window.location.pathname.startsWith("/terms") || window.location.pathname.startsWith("/privacy-policy");
  
  return (
    <>
      {isSmallScreen ? (
        // Mobile sidebar component
        <NavbarMobile scrollToSection={scrollToSection} course={course}/>
      ) : (
        // Desktop Navbar
        <AppBar
          position="static"
          color="inherit"
          elevation={1}
          sx={{ py: 1.5, px: { xs: 2, md: 8 }, backdropFilter: "blur(10px)" }}
        >
          <Toolbar disableGutters sx={{ justifyContent: "space-between" }}>
            <Box display="flex" alignItems="center" gap={1} sx={{ cursor: "pointer" }} onClick={() => !(course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) && (window.location.href = "/")}>
              <img src={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT)  ? PaperliveLogo : PaperliveLogo} alt="Paperlive Learning" height={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? "32" :"32"} width={(course === EXECUTIVE_PG_DEVOPS_PROGRAM || course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) ? "100" :"100"}/>
            </Box>

            <Box display="flex" alignItems="center" gap={4}>
              { !(course === EXECUTIVE_PG_DEVOPS_PROGRAM_SHORT) && <><CourseDropdown>Courses</CourseDropdown>

              <Typography
                sx={{ cursor: "pointer", fontFamily: "Poppins" }}
                onClick={() => (window.location.href = "/blog")}
              >
                Blog
              </Typography>

              {!isBlogPage && <Typography
                sx={{ cursor: "pointer", fontFamily: "Poppins" }}
                onClick={() => scrollToSection("refer")}
              >
                Invite & Earn
              </Typography>}</>}

              <Button
                aria-label="Call Now"
                variant="contained"
                sx={{ background: "#000", fontFamily: "Poppins" }}
                onClick={() => window.open("tel:+918197868030", "_self")}
              >
                <LocalPhoneIcon /> +91 8197868030
              </Button>
            </Box>
          </Toolbar>
        </AppBar>
      )}
    </>
  );
};

export default Navbar;
